import { IonSegment, IonSegmentButton, IonLabel } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/locationShow";
import { selectSegmentSelected } from "../../../store/locationShow/selectors/selectSegmentSelected";
import { FormsSubmittedSection } from "./FormsSubmittedSection";
import { HistorySection } from "./HistorySection";
import { InfoSection } from "./InfoSection";
import { LocationDocumentsFolder } from "./LocationDocumentsFolder";
import { TodoListSection } from "./TodoListSection";
import { UserRolesSection } from "./UserRolesSection";
import { useEffect } from "react";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  useEffect(() => {
    dispatch(setSegmentSelected("todoList"));
    return () => {
      dispatch(setSegmentSelected(""));
    };
  }, []);
  return (
    <section>
      <section className="ion-padding-horizontal">
        <IonSegment
          onIonChange={(e) => {
            dispatch(setSegmentSelected(e.detail.value || ""));
          }}
          value={segmentSelected}
          color="primary"
          style={{ maxWidth: "500px" }}
        >
          {/* <IonSegmentButton value="history">
            <IonLabel>Bitácora</IonLabel>
          </IonSegmentButton> */}
          <IonSegmentButton value="todoList">
            <IonLabel>Acuerdos</IonLabel>
          </IonSegmentButton>
          {/* <IonSegmentButton value="docsList">
            <IonLabel>Documentos</IonLabel>
          </IonSegmentButton> */}
          <IonSegmentButton value="roles">
            <IonLabel>Colaboradores</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </section>
      <section style={{ maxWidth: "1000px" }} className="ion-margin-top">
        {/* {segmentSelected === "info" && <InfoSection />} */}
        {/* {segmentSelected === "history" && <HistorySection />} */}
        {segmentSelected === "todoList" && <TodoListSection />}
        {/* {segmentSelected === "docsList" && <LocationDocumentsFolder />} */}
        {segmentSelected === "roles" && <UserRolesSection />}
      </section>
    </section>
  );
};
